export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-nav">
          <a href="/">Home</a>
<a href="/about">About</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms & Conditions</a>
          <a href="/contact">Contact</a>
        </div>
        <p className="footer-copy">&copy; 2026 Printable Graph Paper. All rights reserved.</p>
      </div>
    </footer>
  );
}